module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"create":"Criar um novo plano...","free":"Grátis"}}')
  delete Component.options._Ctor
}
